import { FC } from 'react'

interface Props {
  title: string
}

export const EmbroideryPromoHeader: FC<Props> = ({ title }) => {
  return <span>{title}</span>
}
